import { lazy } from 'react';

// project imports
import MainLayout from 'jsx/layout/MainLayout';
import Loadable from 'jsx/components/utilities/Loadable';
import AuthGuard from 'utils/route-guard/AuthGuard';

// employee routes
const Dashboard = Loadable(lazy(() => import('jsx/views/dashboard/employee')));
const Expenses = Loadable(lazy(() => import('jsx/views/expenses/entry')));
const Details = Loadable(lazy(() => import('jsx/views/employees/employee')));
const Profile = Loadable(lazy(() => import('jsx/views/profile')));
// const TimeSheet = Loadable(lazy(() => import('jsx/views/timesheet/employee')));
const TimeSheet = Loadable(lazy(() => import('jsx/views/timesheet/employer')));
const Payroll = Loadable(lazy(() => import('jsx/views/payroll/employee')));
const Savings = Loadable(lazy(() => import('jsx/views/savings')));
const EmployeeProfile = Loadable(lazy(() => import('jsx/views/employees/EmployeeProfile')));
const ChangePassword = Loadable(lazy(() => import('jsx/pages/authentication/auth-forms/ChangePassword')));
const AuthForgotPassword = Loadable(lazy(() => import('jsx/pages/authentication/authentication/ForgotPassword')));
// const Support = Loadable(lazy(() => import('jsx/views/support')));

// ==============================|| EMPLOYEE ROUTING ||============================== //

const EmployeeRoutes = {
    path: '/employee',
    element: (
        <AuthGuard>
            <MainLayout />
        </AuthGuard>
    ),
    children: [
        {
            path: 'dashboard',
            element: <Dashboard />
        },
        {
            path: 'timesheet',
            element: <TimeSheet />
        },
        {
            path: 'savings',
            element: <Savings />
        },
        {
            path: 'employees',
            element: <Details />
        },
        {
            path: 'profile/:employee_uuid',
            element: <EmployeeProfile />
        },
        {
            path: 'expenses',
            element: <Expenses />
        },
        {
            path: 'payroll',
            element: <Payroll />
        },
        // {
        //     path: 'support',
        //     element: <Support />
        // },
        {
            path: 'account/profile',
            element: <Profile />
        },
        {
            path: 'change-password',
            element: <ChangePassword />
        },
        {
            path: 'forgot',
            element: <AuthForgotPassword />
        },
    ]
};

export default EmployeeRoutes;
